const partialCancellationConfig = {
    allowToCancellationService: ['ausflug', 'sitzplatzreservierung'],
};
export default partialCancellationConfig;
